import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { TokenDto } from '../../dto/TokenDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteServiceToken = async (dto: TokenDto) => {
  const params: IApiParams = {
    url: '/localbase/deleteServiceToken.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', dto);
};
